export const apiFetch = (url, options = {}) => fetch(url, options);

const ADMIN_TOKEN_STORAGE_KEY = 'vmb_admin_access_token';
const ADMIN_ROLE_STORAGE_KEY = 'vmb_admin_role';

export const getAdminToken = () => window.localStorage.getItem(ADMIN_TOKEN_STORAGE_KEY) || '';
export const getAdminRole = () => {
	const storedRole = window.localStorage.getItem(ADMIN_ROLE_STORAGE_KEY) || '';
	if (storedRole) return storedRole;

	const token = getAdminToken();
	if (!token || !token.includes('.')) return '';

	try {
		const payloadBase64 = token.split('.')[1];
		const payloadJson = window.atob(payloadBase64.replace(/-/g, '+').replace(/_/g, '/'));
		const payload = JSON.parse(payloadJson);
		return payload.role || '';
	} catch {
		return '';
	}
};

export const setAdminToken = (token, role = '') => {
	if (!token) {
		window.localStorage.removeItem(ADMIN_TOKEN_STORAGE_KEY);
		window.localStorage.removeItem(ADMIN_ROLE_STORAGE_KEY);
		return;
	}
	window.localStorage.setItem(ADMIN_TOKEN_STORAGE_KEY, token);
	if (role) {
		window.localStorage.setItem(ADMIN_ROLE_STORAGE_KEY, role);
	}
};

export const adminApiFetch = (url, options = {}) => {
	const adminKey = window._env_?.REACT_APP_ADMIN_API_KEY || process.env.REACT_APP_ADMIN_API_KEY || '';
	const adminToken = getAdminToken();
	const headers = {
		...(options.headers || {}),
	};
	if (adminToken) {
		headers['Authorization'] = `Bearer ${adminToken}`;
	}
	if (adminKey) {
		headers['X-Admin-Key'] = adminKey;
	}
	return fetch(url, {
		...options,
		headers,
	});
};

export const adminLogin = async (baseUrl, username, password) => {
	const response = await apiFetch(`${baseUrl}/auth/admin/login`, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({ username, password }),
	});
	if (!response.ok) {
		throw new Error('Admin login failed.');
	}
	const payload = await response.json();
	setAdminToken(payload.access_token || '', payload.role || '');
	return payload;
};

export const normalizeVilla = (villa = {}) => {
	const resolvedId = villa.id ?? villa._id ?? '';

	return {
		...villa,
		id: resolvedId ? String(resolvedId) : '',
		_id: villa._id ?? resolvedId ?? ''
	};
};

export const normalizeVillas = (villas = []) => villas.map(normalizeVilla);

export const normalizeMenu = (menu = {}) => {
	const resolvedId = menu.id ?? menu._id ?? '';

	return {
		...menu,
		id: resolvedId ? String(resolvedId) : '',
		_id: menu._id ?? resolvedId ?? ''
	};
};

export const normalizeMenus = (menus = []) => menus.map(normalizeMenu);

